import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MainFacade } from 'src/app/pages/main.facade';

@Component({
  selector: 'app-profileedit',
  templateUrl: './profileedit.component.html',
  styleUrls: ['./profileedit.component.scss']
})
export class ProfileeditComponent implements OnInit , OnDestroy {
  public login$: Observable<any>|undefined;
  public error$: Observable<any>|undefined;
  public user$: Observable<any>|undefined;
  public nfts$: Observable<any>|undefined;
  public levels$: Observable<any>|undefined;
  private destroy$ = new Subject();
  
  user:any;
  avatarSelect:any ='';
  urlmanual:any='';
  newUsername:any='';
  

  constructor(private mainfacade:MainFacade) { 

  }

  ngOnInit(): void {
    this.setObservables();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  setObservables() {
    this.login$ = this.mainfacade.login$;
    this.error$ = this.mainfacade.error$;
    this.nfts$ = this.mainfacade.nfts$
    this.user$ = this.mainfacade.user$;
    
    this.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 

      if(message){
        this.user = message;
        this.newUsername = this.user?.UserName;
      }

    });

  }


  selectAvatar(id:string, contract:string, nft:any){
    //if select then deselect
    this.avatarSelect = {
      token_id:id, 
      token_address:contract,
      url:nft.Image
    }
   
  }

  isAvatarSelected(id:string, contract:string){
    return this.avatarSelect.token_address === contract && this.avatarSelect.token_id === id;
  }

  confirmAvatar(){
    let url = '';
    if(this.avatarSelect){
      url=this.avatarSelect.url;
    }
    else if(this.urlmanual){
      url=this.urlmanual;
    }
    else{
      url = this.user.ImageUrl;
    }

    if(this.newUsername=== ''){
      this.newUsername = this.user.UserName;
    }
    this.mainfacade.setShowProfileEdit(false);
    this.mainfacade.updateAvatar(this.user.Id, url, this.user.Wallet, this.newUsername);
  }

  closeProfileEdit(){
    this.mainfacade.setShowProfileEdit(false);
  }

}
